import { getJwt } from '@session/getJwt';
import { isEmpty } from 'lodash';

export function isUserLoggedIn() {
  return !isEmpty(getJwt());
}
